<template>
  <div
    :id="name.toString()"
    class="bushel-tag font-weight-normal"
  >
    <i
      v-if="icon"
      :class="icon"
    />
    {{ name }}
    <BTooltip
      v-if="tooltip"
      :target="name.toString()"
      triggers="hover"
    >
      {{ tooltip }}
    </BTooltip>
  </div>
</template>

<script>
export default {
  props: {
    name: { type: [String, Number, Boolean], required: true },
    icon: { type: String, default: null },
    tooltip: { type: String, default: null },
  },
  data() {
    return {};
  },
};
</script>
